import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class InternalMapService {

  constructor() { }
  public markerChanged = new ReplaySubject<void>();
}
